import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { APP_SCHEME } from "@/lib/native";

// Web bounce page for in-app Google sign-in: hands the one-time session_id back to the native app.
export default function NativeAuthReturn() {
  const [deepLink, setDeepLink] = useState(null);

  useEffect(() => {
    const m = (window.location.hash || "").match(/session_id=([^&]+)/);
    if (!m) return;
    const link = `${APP_SCHEME}://auth-callback#session_id=${m[1]}`;
    setDeepLink(link);
    window.history.replaceState(null, "", window.location.pathname);
    window.location.href = link;
  }, []);

  return (
    <div className="min-h-[70vh] grid place-items-center px-6" data-testid="native-auth-return">
      <div className="text-center max-w-sm">
        {deepLink ? (
          <>
            <Loader2 className="w-8 h-8 animate-spin mx-auto text-primary" />
            <h1 className="serif text-2xl mt-4">Returning to the app…</h1>
            <Button asChild className="mt-6 rounded-full" data-testid="native-auth-return-open">
              <a href={deepLink}>Open Dividend Portfolio Planner</a>
            </Button>
          </>
        ) : (
          <h1 className="serif text-2xl">This link only works from the mobile app.</h1>
        )}
      </div>
    </div>
  );
}
